import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c9f90db2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c9f90db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f90db2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlaceCardv2: require('/workspace/components/PlaceCardv2.vue').default,ActivityCard: require('/workspace/components/ActivityCard.vue').default,ShimmerEffect: require('/workspace/components/ShimmerEffect.vue').default,FilterCard: require('/workspace/components/FilterCard.vue').default,RentalCardV3: require('/workspace/components/RentalCardV3.vue').default,PlaceCard: require('/workspace/components/PlaceCard.vue').default,ActivityBlog: require('/workspace/components/ActivityBlog/ActivityBlog.vue').default})
